export enum appTypes {
  APP_FETCH_PUBLIC_MENU = '[APP] Fetch public menu',
  APP_FETCH_SHOPPING_PRODUCTS = '[APP] Fetch shopping cart products',
  APP_FETCH_STATES = '[APP] Fetch states',
  APP_FETCH_SPECIALTIES = '[APP] Fetch specialties',
  APP_FETCH_TAGS = '[APP] Fetch tags',
  APP_FETCH_BRANDS = '[APP] Fetch brands',
  APP_FETCH_CATEGORIES = '[APP] Fetch categories',
  APP_UPDATE_CHALLENGES = '[APP] Update challenges',
  APP_FETCH_USER_HOME = '[APP] Fetch user home page',
  APP_FETCH_USER_MENU = '[APP] Fetch user menu',
  APP_FETCH_EMBRACE_PRACTICES = '[APP] Fetch Embrace Practices - Registered',
  APP_FETCH_LIWW_PRACTICES = '[APP] Fetch LIWW Practices - Unregistered',
  APP_FETCH_USA_PRACTICES = '[APP] Fetch USA Practices',
  APP_SET_COMPLETED_PROFILE_USER = '[APP] Change status of CompletedStatus to True',
  APP_SET_SALESFORCE_CENTER = '[APP] Set Salesforce center',
  APP_SET_BREADCRUMBS = '[APP] Set Breadcrumbs',
  APP_SET_STATIC_PAGE = '[APP] Set Static page',
  APP_SET_CHALLENGE = '[APP] Set Challenge',
  APP_SET_PLATFORM_STATUS = '[APP] Set platform status',
  APP_SET_FOOTER_HEIGHT = '[APP] set footer height',
  APP_SET_ACTIONS = '[APP] set actions',
  APP_SET_SCAN_ERROR = '[APP] Set scan error',
  APP_SET_FROM_SCAN = '[APP] Set user comes from QR scan flow',
  APP_DATA_SCAN = '[APP] Set data when scanning QR',
  APP_SET_CAMPAIGN = '[APP] Set user campaigns',
  APP_SET_SHOW_DISCOVERY_MODAL = '[APP] Set show discovery modal',
  APP_SET_SHOW_SPECIAL_DISCOVERY_COUPON = '[APP] Set show special discovery coupon',
  APP_SET_STATIC_PAGE_DISCOVERY_MODAL = '[APP] Set static page discovery modal',
}
